import useAtomAssistEventHandlers from "src/views/assistant/hooks/useAtomAssistEventHandlers";
import { useCallback } from "react";
import { usePartsAIStore } from "../store/PartsAIStore";
import { StreamingState } from "src/reusable/Chat/ChatStreaming/stores/StreamingStore";

const usePartsAIEventHandlers = () => {
  // Reuse AtomAssist event handlers for core functionality
  const { metadataHandler: atomAssistMetadataHandler, messageHandler } =
    useAtomAssistEventHandlers();

  // Get Parts AI-specific store actions
  const setDialogueId = usePartsAIStore((state) => state.setDialogueId);

  // Extend metadata handler with Parts AI-specific logic
  const metadataHandler = useCallback(
    (metadata: any, streamingState: StreamingState) => {
      // Sync dialogue ID to Parts AI store if present
      if (metadata?.dialogue_id) {
        setDialogueId(metadata.dialogue_id);
      }

      // Delegate to AtomAssist handler for common functionality
      // (assigned_message_id, assistant_response_sources, etc.)
      atomAssistMetadataHandler(metadata, streamingState);
    },
    [setDialogueId, atomAssistMetadataHandler],
  );

  return {
    metadataHandler,
    messageHandler, // Reuse AtomAssist message handler directly
  };
};

export default usePartsAIEventHandlers;
